import { render, staticRenderFns } from "./OverflowWrapper.vue?vue&type=template&id=57e3c765&scoped=true&"
import script from "./OverflowWrapper.vue?vue&type=script&lang=ts&"
export * from "./OverflowWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./OverflowWrapper.vue?vue&type=style&index=0&id=57e3c765&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e3c765",
  null
  
)

export default component.exports